export default __webpack_public_path__ + "static/media/reef_cutter.27919109.jpg";